import React from 'react'

export default ({ notification, onDismiss = () => {} }) => {
    let className = 'notification alert alert-dismissible alert-' + (notification.type ? notification.type.replace('error', 'danger') : 'info')
    return (
        <div className={className} role="alert">
            <button type="button" className="close" onClick={onDismiss}><span aria-hidden="true">&times;</span></button>
            {notification.message}
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/Notification.jsx